import React, { useState } from "react";

const FormTabs = () => {
  const [activeTab, setActiveTab] = useState("customer");

  return (
    <div
      className="px-3 py-4"
      style={{
        backgroundColor: "#FFF7EC",
        borderRadius: "6px",
        width: "100%",
      }}
    >
      <div className="d-flex gap-2">
        {/* Customer Data & Feedback Form */}
        <button
          className="btn d-flex align-items-center gap-1"
          onClick={() => setActiveTab("customer")}
          style={{
            backgroundColor: activeTab === "customer" ? "#7A1E5C" : "#F3E6EF",
            color: activeTab === "customer" ? "#fff" : "#7A1E5C",
            fontSize: "12px",
            padding: "4px 10px",
            borderRadius: "4px",
            border: "none",
          }}
        >
          + Customer Data & Feedback Form
        </button>
        <button
          style={{
            backgroundColor: "#FFD166",
            color: "#ffffff",
            borderRadius: "25%",
            border: "none", // 👈 removes border
            outline: "none", // 👈 removes focus outline
            padding: "4px 8px", // optional (for better look)
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          0
        </button>

        {/* Staff Checklist */}
        <button
          className="btn d-flex align-items-center gap-1"
          onClick={() => setActiveTab("staff")}
          style={{
            backgroundColor: activeTab === "staff" ? "#7A1E5C" : "#F3E6EF",
            color: activeTab === "staff" ? "#fff" : "#7A1E5C",
            fontSize: "12px",
            padding: "4px 10px",
            borderRadius: "4px",
            border: "none",
          }}
        >
          + Staff Checklist
        </button>
        <button
          style={{
            backgroundColor: "#FFD166",
            color: "#ffffff",
            borderRadius: "25%",
            border: "none", // 👈 removes border
            outline: "none", // 👈 removes focus outline
            padding: "4px 8px", // optional (for better look)
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          0
        </button>
      </div>
    </div>
  );
};

export default FormTabs;
